import { apiFetch } from './client';

export async function publicCreateInviteRequest(payload) {
  return apiFetch('/public/invite-requests', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function publicSubmitCohortSignup(payload) {
  return apiFetch('/public/cohort-signups', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
